module.exports = __webpack_public_path__ + "static/img/logo1.aff6dbc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo1.png
// module id = Yn/e
// module chunks = 1